import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Pump, PumpRoomInstallation } from '@authority-labs/api-interfaces';
import { MeasureType } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-pump-room-installation-inspection',
  templateUrl: './pump-room-installation-inspection.component.html',
  styleUrls: ['./pump-room-installation-inspection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PumpRoomInstallationInspectionComponent {
  @Input() data: PumpRoomInstallation;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  characteristics: MeasureType[] = [MeasureType.Pressure];
  selectedTab = 0;

  tabName(index: number) {
    return `משאבה ${index + 1}`;
  }

  onDataChange(): void {
    this.dataChange.emit();
  }

  addTest(): void {
    this.data.pumps.push(new Pump());
    this.selectedTab = this.data.pumps.length - 1;
    this.onDataChange();
  }

  removeTest(index: number): void {
    this.data.pumps.splice(index, 1);
    this.onDataChange();
  }
}
